__webpack_require__.p = "/reports-legacy-reports-banner-non-dismissable/referrals-hub/";